module.exports = __webpack_public_path__ + "img/map.fed850ea.jpg";